<template>
  <div class="register-container">
    <div class="register-title text-center mb-8">
      <!--<img src="/register-title.png" width="200" class="max-w-full" />-->
    </div>
    <div class="register-form">
      <div class="register-form-item">
        <div class="input-label">Phone Number</div>
        <el-input v-model="logonInfo.phone" placeholder="Phone Number">
        </el-input>
      </div>
      <div class="register-form-item">
        <div class="input-label">
          Password

          <!-- <img src="/Quicker124.png" class="label-icon" /> -->
        </div>
        <el-input v-model="logonInfo.password" type="password" placeholder="Create Password">
        </el-input>
      </div>
      <div class="register-form-item">
        <div class="input-label">
          Confirm Password
          <!-- <img src="/Quicker124.png" class="label-icon" /> -->
        </div>
        <el-input v-model="repassword" type="password" placeholder="Confirm Password">
        </el-input>
      </div>
      <div class="register-form-item">
        <div class="flex-1">
          <div class="input-label">Auth Code</div>
          <el-input v-model="inputVue" placeholder="Auth Code"> </el-input>
        </div>

        <canvas id="canvas" :width="width" :height="height" @click="handleDraw"></canvas>
      </div>
      <div class="login-actions">
        <button class="login-button" @click="logon">Sign Up</button>
        <p class="login-actions-text">
          Already have an account?
          <a style="color: #3c26f0;" href="#/Login">Login here!</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomNumCanvas } from "@/utils";
import axios from "axios";
import { throttle } from "lodash";
export default {
  data() {
    return {
      loginyzm: "",
      inputVue: "",
      login: false,
      input: "",
      loginInfo: {
        password: "",
        phone: "",
      },
      logonInfo: {
        password: "",
        phone: "",
      },
      repassword: "",

      allTexts: "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890", // 字符串
      width: 120,
      height: 40,
      imgCode: "",
      imhCode1: "",
    };
  },
  watch: {},
  mounted() {
    // 初始化绘制图片验证码
    this.imgCode = this.draw();
  },
  methods: {
    // 需要节流的方法
    handleClick: throttle(function () {
      // 处理点击事件
    }, 1000), // 1000毫秒的节流

    sw() {
      this.$router.push("/Login");
    },

    logon: throttle(function () {
      if (this.logonInfo.phone == "" || this.logonInfo.password == "") {
        this.$message.error("Phone or Password is null");
        return;
      }
      // 用于检查是否只包含英文和数字，并且不包含空格
      const regForPassword = /^[A-Za-z0-9]+$/;
      // 用于检查是否包含空格
      const regForSpace = /\s/;
      // 检查手机号（假设手机号不应该包含空格）
      if (regForSpace.test(this.logonInfo.phone)) {
        this.$message.error("Phone number cannot contain spaces");
        return;
      } else if (!regForPassword.test(this.logonInfo.phone)) {
        this.$message.error(
          "Phone number should only contain letters and numbers"
        );
        return;
      }
      // const reg = /^\d+$/;
      // if (!reg.test(this.logonInfo.phone)) {
      //   this.$message.error("Phone invalid!!!");
      //   return;
      // }
      // if (this.logonInfo.phone.length < 3 || this.logonInfo.phone.length > 30) {
      //   this.$message.error("Phone length is 1 to 30 digits");
      //   return;
      // }
      if (this.repassword == this.logonInfo.password) {
      } else {
        this.$message.error("The passwords are not the same.");
        return;
      }

      if (
        this.logonInfo.password.length < 6 ||
        this.logonInfo.password.length > 10
      ) {
        this.$message.error("Password length is 6 to 10 digits");
        return;
      }

      if (this.inputVue.toLowerCase() != this.loginyzm.toLowerCase()) {
        // ////console.log(this.inputVue.toLowerCase())
        // ////console.log(this.loginyzm.toLowerCase()),

        this.$message.error("Captcha error");
        return;
      }
      //  //////console.log(this.logonInfo);
      axios
        .post("/puserSys/puser/logon", this.logonInfo)
        .then((res) => {
          //  ////console.log(res);
          if (res.data.msg == "Logon Success") {
            // ////console.log(res);
            this.loginInfo.password = this.logonInfo.password;
            this.loginInfo.phone = this.logonInfo.phone;
            axios
              .post("/puserSys/puser/login", this.loginInfo, {
                withCredentials: true,
              })
              .then((res) => {
                ////console.log("userLogin", res.data);
                sessionStorage.setItem("tokenUrl", "");
                if (res.data.data) {
                  sessionStorage.setItem("token", res.data.data.userid);
                  sessionStorage.setItem("tokenUrl", res.data.data.Token);
                  sessionStorage.setItem(
                    "loginInfopassword",
                    this.loginInfo.password
                  );
                  sessionStorage.setItem("phone", this.loginInfo.phone);
                  this.$message.success("Login success");
                  this.$router.push("/");
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(() => { });

            return;
          }

          if (res.data.code == 500) {
            this.$message.error("User Already Exists");
            return;
          }
        })
        .catch(() => { });
    }, 3000),

    //todo 点击图片刷新
    handleDraw() {
      this.imgCode = this.draw();
    },
    handleDraw() {
      this.imgCode1 = this.draw();
    },
    //todo 绘图
    draw() {
      const canvas = document.getElementById("canvas");
      this.loginyzm = getRandomNumCanvas({
        canvas,
        allTexts: this.allTexts,
        width: this.width,
        height: this.height,
      });
    },
    //数字
    handleInput() {
      const reg = /^\d+$/; // 匹配纯数字的正则表达式
      this.isNumberString = reg.test(this.inputValue);
    },
  },
};
</script>

<style scoped>
.login-actions {
  margin-top: 10px;
  align-items: center;
  justify-content: space-evenly;
}

.text-center {
  text-align: center;
}

.max-w-full {
  max-width: 100%;
}

.mb-8 {
  margin-bottom: 4rem;
}

.flex-1 {
  flex: 1;
}

.login-button {
  padding: 10px 15px;
  font-size: 20px;
  border: none;
  font-weight: bold;
  font-size: 24px;
  background-color: #3c26f0;
  color: #fff;
}

button {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
}

.register-title {
  padding-top: 20px;
  margin-bottom: 10px;
}

.register-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("/public/registernew.png") no-repeat;
  background-size: 100% 100%;
}

.register-form {
  width: 80%;
  max-width: 560px;
  padding-top: 20vh;
}

.register-form-item {
  display: flex;
  padding: 20px 0;
  border-radius: 10px;
  position: relative;
  gap: 10px;
}

.register-form-item .input-label {
  position: absolute;
  top: -4px;
  left: 0;
  padding: 4px 8px 2px;
  border-radius: 4px;
  font-size: 14px;
  color: #3c26f0;
}

.register-form-item .input-label .label-icon {
  position: absolute;
  right: -30px;
  top: 0px;
  height: 18px;
}

.img-canvas {
  height: 40px;
  border-radius: 8px;
}

#canvas {
  border-radius: 4px;
}

.login-button {
  width: 100%;
  font-size: 28px;
  text-transform: uppercase;
}

.login-actions-text {
  background-color: #fff;
  font-weight: bold;
  font-size: 16px;
  padding: 12px 8px;
  border-radius: 4px;
  display: inline-block;
}

:deep(.el-input) {
  border-radius: 8px;
}

:deep(.el-input .el-input__inner) {
  font-size: 20px;
  font-weight: bold;
  border: 2px solid #3c26f0;
}
#canvas{
  border: 2px solid #3c26f0;
  height: 36px;
}

:deep(.el-input__inner::-webkit-input-placeholder) {
  font-size: 15px;
  font-weight: bold;
}
</style>
